<template>
  <v-form v-model="valid">
    <div class="row__expanded">
      <v-card elevation="0">
        <v-container fluid>
          <v-skeleton-loader
            type="paragraph"
            v-if="loading"
          ></v-skeleton-loader>
          <v-row v-else>
            <v-col cols="12">
                <v-col cols="12">
                  <h3 class="secondary--text text-left">
                    {{
                      $t(
                        'fleet_management.points_of_interest.data_table.row_expanded.description_fields'
                      )
                    }}
                  </h3>
                </v-col>
                <v-col cols="12">
                  <div>
                    <div v-if="!editMode" class="secondary--text text-body-1">
                      {{ item.description }}
                    </div>
                  </div>
                </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import { PointsHelpers } from '@/helpers/mainExports'
import store from '@/store'

export default {
  name: 'RowExpanded',
  components: {
    SvgIcon
  },
  props: {
    item: {
      type: Object
    },
    editMode: {
      type: Boolean
    },
    isAdmin: {
      type: Boolean
    }
  },
  async created() {
    await this.fillPointDataById()
  },
  data() {
    return {
      valid: false,
      loading: false
    }
  },
  methods: {
    async fillPointDataById() {
      if (Boolean(this.item)) {
        try {
          this.loading = true
          const res = await PointsHelpers.getPoint({ id: this.item.id })
          const idx = this.$store.getters.getPointsSortedByName
            .findIndex(point => point.id === this.item.id)
          Object.assign(this.$store.getters.getPointsSortedByName[idx], res)
        } catch (err) {
          const errorText = PointsHelpers.getErrorMessageByCode(err.error)
          const snackbar = {
            text: errorText
          }
          store.dispatch('ui/setSnackbar', snackbar)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped>
.divider-dotted {
  border-width: 0;
  background-size: 6px 3px;
  background-repeat: repeat-x;
  background-position-y: bottom;
  background-image: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.15) 0.05rem,
    transparent 1.5px
  );
  height: 3px;
}
</style>
